export enum EnvironmentName {
  DEV = 'dev',
  PROD = 'prod',
}
